import React from "react";
import HomeNavbar from "../../frontendpages/components/home/HomeNavbar";
import Footer from "../../frontendpages/components/home/Footer";
import useSessionTimeout from "../commoncomponent/useSessionTimeout";

const Applayout = ({ children, showFooter, showNavbar = true }) => {
  useSessionTimeout();
  return (
    <>
      {showNavbar && <HomeNavbar />}
      <div style={{ backgroundColor: "#E1DAFF", width: "100%", overflowX: "hidden" }}>
        <main style={{ width: "100%", boxSizing: "border-box" }}>{children}</main>
        {showFooter && <Footer />}
      </div>
    </>
  );
};

export default Applayout;
